import styled from 'styled-components'
import {
	WHITE,
	MEDIUMORANGE,
	GREEN,
} from '../../../../../../styles/colors.style'
import { breakpoints } from '../../../../../../constants'

export const BoxBill = styled.div`
	width: 100%;
`
export const Message = styled.small`
	font: 15px/19px 'Source Sans Pro';
	padding-bottom: 5px;
	display: block;
	text-align: center;

	&.white {
		color: ${WHITE};
	}
	&.orange {
		color: ${MEDIUMORANGE};
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const Billed = styled.p`
	display: inline-block;
	font: 600 40px/50px 'Source Sans Pro';
	color: ${WHITE};
	margin: 0;
	padding: 0;
	position: relative;
	text-align: center;

	@media (min-width: ${breakpoints.MOBILE}px) {
	}

	sup {
		right: -14%;
		top: 14px;
		position: absolute;
	}
`

export const CreditValue = styled.div`
	font: 15px/19px 'Source Sans Pro';
	padding: 5px 0;
	color: ${WHITE} !important;
	text-align: center;
	font-weight: 600;
	background-color: ${GREEN};
	padding-top: 5px;
	margin: 5px 40px;
	border-radius: 15px;
`

export const NavigationContainer = styled.div`
	display: flex;
	justify-content: space-between;
`

export const ArrowButton = styled.button`
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;

	.arrow {
		width: 12px;
		height: 12px;
		border-bottom: 3px solid #ffa42d;
		border-right: 3px solid #ffa42d;
		border-radius: 2px;
		transform: rotate(315deg) translate(20%, -60%);
	}

	.arrow.mirrored {
		transform: rotate(135deg) translate(-60%, 20%);
	}
`
